/**
 * NIGHTBOUND - creature art resolution.
 *
 * The renderer probes, in order:
 *   state art  ->  idle art  ->  procedural placeholder.
 *
 * Combines both candidate lists into one probe chain so a single hook call
 * resolves the whole fallback story.
 */

import type { CreatureStateId } from '../../shared/creatureState'
import { creatureIdleCandidates, creatureStateCandidates } from '../../shared/assets/manifest'

export function creatureArtCandidates(speciesKey: string, state: CreatureStateId): string[] {
  const candidates = [...creatureStateCandidates(speciesKey, state)]
  if (state !== 'IDLE') candidates.push(...creatureIdleCandidates(speciesKey))
  return candidates
}
